import { ICourse } from '@/types/course'

import React, { memo } from 'react'
import { ImageWithFallback } from '../../shared/components/image-with-fallback'

type CourseBannerProps = {
  courseInfo: Pick<
    ICourse,
    '_id' | 'categories' | 'educationProvider' | 'imageUrl'
  >
  aspectRatio?: 'top-course-banner' | 'course-card'
} & React.HTMLAttributes<HTMLDivElement>

function CourseBanner({
  courseInfo,
  aspectRatio = 'course-card',
  ...props
}: CourseBannerProps) {
  const {
    categories: [
      { name: categoryName = '', slug: categorySlug = '' } = {},
    ] = [],
  } = courseInfo ?? {}

  return categorySlug ? (
    <div {...props} className={`relative ${props.className ?? ''}`}>
      <div className="absolute inset-0 bg-enrolment-card-bg mix-blend-multiply" />
      <ImageWithFallback
        alt={categoryName}
        src={`/images/taxonomy-images/card-${categorySlug}.jpg`}
        fallbackSrc="/images/taxonomy-images/card-fallback.jpg"
        width={1600}
        height={420}
        className={`w-full object-cover ${aspectRatio === 'top-course-banner' ? 'aspect-top-course-banner' : 'aspect-course-card'}`}
      />

      <div className="absolute inset-0">
        <div className="flex h-full flex-col items-center justify-center gap-3">
          {courseInfo?.educationProvider?.logoUrl && (
            <ImageWithFallback
              src={courseInfo?.educationProvider?.logoUrl}
              alt={`${courseInfo?.educationProvider?.name} logo`}
              width={90}
              height={90}
              className="h-[90px] w-[90px] rounded-full object-contain"
            />
          )}
          <p className="text-center font-medium text-white">
            {courseInfo.educationProvider?.name ?? ''}
          </p>
        </div>
      </div>
    </div>
  ) : null
}

const MemoizedCourseBanner = memo(CourseBanner)

export { MemoizedCourseBanner as CourseBanner }
